export default [
    {
        path: "documentary-settlements",
        name: "operations-documentary-settlements",
        redirect: { name: "operations-documentary-settlements-grid" },
        component: () => import("@/views/operations/views/documentary-settlements/DocumentarySettlements.vue"),
        meta: {
            section: 34,
            breadcrumb: [
                {
                    text: "Documentary settlements",
                    active: true,
                },
            ],

            tabs: [
                {
                    title: "Travels",
                    name: "operations-service-orders-list",
                },
            ],
        },
        children: [
            {
                path: "grid",
                name: "operations-documentary-settlements-grid",
                component: () =>
                    import("@/views/operations/views/documentary-settlements/components/DocumentarySettlementsGrid.vue"),
                meta: {
                    section: 34,
                    pageTitle: "Documentary settlements",
                    breadcrumb: [
                        {
                            text: "Travels",
                        },
                    ],
                },
            },
        ]
    }
]